// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CloneFromV1Wizard_wrap__50JBW","steps":"CloneFromV1Wizard_steps__3ZZxq","tableWrap":"CloneFromV1Wizard_tableWrap___l0dA"};